import React, { useEffect, useState, useRef } from 'react'
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import { toast } from "react-toastify";
import FailedModal from "../../CustomModal/Failed";
import Camera from "react-html5-camera-photo";
import Moment from "moment";
import FileUpload from "../../FileUploads/FileUpload";
import distanceBetweenTwoPoints from "../../DistanceBetweenTwoPoints";
import DistanceCalculatorV2 from "../../DistanceCalculatorV2";
import {generateRandomString, versionCheck} from "../../Common";
import useSiteDistance from "../../../hooks/currentlocation/useSiteDistance";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import DistanceCalculator from "../../DistanceCalculator/Calculator";

const CompleteFastTagTollActivity = ({
    documentUploadUrlPublic,
    documentUrlDataPublic,
    history,
    match,
    getActivity,
    types = [],
    activitySave,
    saveActivityResponse = [],
    markAttendance,
    attendance = [],
    viewActivity,
    getActivityDetails = [],
    isCheckoutDetails = [],
    isCheckout,
    tollById,
    tollView = [],
                                         errorLogs,
                                         getInactiveFsesRequest,
                                         getInactiveFsesResponse = []
}) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const currentUserLocation = useRef(null);
    const islatlng = useLatLng();
    let siteDistance = useSiteDistance(
        tollView?.data?.latitude,
        tollView?.data?.longitude
    )
    const [isLoading, setIsLoading] = useState(false)
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        meta_data: {},
        lat: '',
        long: '',
        activity_type_id: '',
        activity_date: '',
        description: '',
        fse_efficiency_selfies: ''
    }])
    const [openCheckIn, setOpenCheckIn] = useState(true)
    const [checkInText, setCheckInText] = useState('Check In')
    const [distance, setDistance] = useState()
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [reason, setReason] = useState([{}])
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('')
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isVirtual, setIsVirtual] = useState(false)
    const [isReqularization, setIsRegularization] = useState(false)
    const [takeSelfie, setTakeSelfie] = useState([])
    const [retake, setRetake] = useState([])
    const [prev, setPrev] = useState(0)
    const [hours, setHours] = useState(2)
    const [roleId, setRoleId] = useState(0);
    const [competitor, setCompetitor] = useState([{name:'', bank: '', employee_type: '', no_of_fse: '', salary: '', min_tags: '', tag_sold: '', upload_proof: ''}])
    const [currentIndex, serCurrentIndex] = useState('')
    const [fse, setFSE] = useState([{phone_no: '', otp: '', text: "Send OTP", selfie: ''}])
    const [open, setOpen] = useState(false);
    const [userId, setUserId] = useState()
    const [deviceId, setDeviceId] = useState('')
    const [isMockLocation, setIsMockLocation] = useState(false)
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false)
    const [taskType, setTakType] = useState("inactive")
    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null)
    const [appVersion, setAppVersion] = useState(null);

    useEffect( async () => {
        const webView = window.localStorage?.webview;
        setAppVersion(window.localStorage?.app_version);
        if(versionCheck('3.0.0')){
            if(webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                console.log("currentUserLocation.current", currentUserLocation.current)
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        }
    }, []);

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        reject('Location access denied.');
                        setIsLocationFetching(false);
                    } else {
                        setLocationStatus('granted')
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
        setIsLoading(false);
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRoleId(window.localStorage.role_id)
            setUserId(window.localStorage.user_id)
            if(window.localStorage?.toll_id &&
                parseInt(window.localStorage.toll_id) !== parseInt(match?.params?.account_id)){
                delete window.localStorage.inactive_fse;
                delete window.localStorage.fse_inventory;
                delete window.localStorage.fse_tag_transfer;
                delete window.localStorage.penalty;
                delete window.localStorage.active_fse_percentage;
                delete window.localStorage.fse_inventory_percentage;
                delete window.localStorage.fse_tag_transfer_percentage;
                delete window.localStorage.penalty_percentage;
                delete window.localStorage.fse_tag_transfer_selfie;
                delete window.localStorage.penalty_selfie;
                delete window.localStorage.fse_inventory_selfie;
                delete window.localStorage.inactive_fse_selfie;
                delete window.localStorage.is_inactive_fse_tab;
                delete window.localStorage.fse_inventory_tab;
                delete window.localStorage.penalty_percentage_tab;
                delete window.localStorage.fse_tag_transfer_tab;
                delete window.localStorage.fse_details;
            }
            window.localStorage.toll_id = match?.params?.account_id;
            if(window.localStorage.fse_details && window.localStorage.fse_details.length > 0){
                setFSE(JSON.parse(window.localStorage.fse_details))
            }
            await getActivity()
            await viewActivity(match?.params?.id)
            await isCheckout(match?.params?.id, match?.params?.account_id, '')
            await tollById(match?.params?.account_id)
            setIsLoading(false)
        })()
    }, [])


    useEffect(() => {
        (async () => {
            if(tollView?.data?.latitude){
                setIsLoading(true)
                await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'inactive');
                setIsLoading(false)
            }
        })()
    }, [tollView])


    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined && attendance?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false)
            var returnObj = JSON.parse(window.localStorage?.previous_url);
            if (returnObj && Object.keys(returnObj).length > 0) {
                delete returnObj[Object.keys(returnObj).length - 1]
                window.localStorage.previous_url = JSON.stringify(returnObj)
            }
            window.location.href = `fast-tag-toll-activity-list/${match?.params?.account_id}`
            // if (checkInText === "Check out") {
            //
            // }
        } else {
            toast.warning(attendance?.message)
        }
    }, [attendance])


    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    useEffect(() => {
        if (isCheckoutDetails?.data !== undefined && Object.keys(isCheckoutDetails?.data).length > 0) {
            // redirect to meeting listing if AM is already check in on diff toll
            if(parseInt(isCheckoutDetails?.data?.account_id) !== parseInt(match?.params?.account_id) ){
                setTimeout(() => {
                    toast.warning("Already check in on toll "+isCheckoutDetails?.data?.client_name+"( "+isCheckoutDetails?.data?.fast_tag_toll_no+" )")
                    window.location.href=`fast-tag-toll-activity-list/${match?.params?.account_id}`;
                }, 500)
            }

            setOpenCheckIn(false)
            let current = new Date();
            let checkInTime = new Date(Moment(isCheckoutDetails?.data?.check_in_date).format('Y-MM-DD H:mm:ss'))
            current = new Date(Moment(current).format('Y-MM-DD H:mm:ss'))
            let spendHours = diff_hours(current, checkInTime)
            setHours(spendHours)
            console.log("sdfv", spendHours)
            // 30 ASM
            if(parseInt(roleId) === 30 && spendHours < 1){
                toast.warning("You can't complete this toll visit before 1 hours")
            } else if(parseInt(roleId) === 29 && spendHours < 1){
                // AM
                toast.warning("You can't complete this toll visit before 1 hours")
            }
        }
    }, [isCheckoutDetails])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if(!versionCheck('3.0.0')) {
            if(islatlng?.lat === null || islatlng?.lng === null ){
                toast.error("Enable your location")
                return false
            }
        } else {
            if(currentUserLocation?.current?.lat === null || currentUserLocation?.current?.long === null ){
                toast.error("Enable your location")
                return false
            }
        }
        // if(parseInt(userId) === 397 || parseInt(userId) === 886 || parseInt(userId) === 804 || parseInt(userId) === 754 || parseInt(userId) === 526
        //     || parseInt(userId) === 522 || parseInt(userId) === 516 || parseInt(userId) === 518 || parseInt(userId) === 658 || parseInt(userId) === 496
        // ) {
        //     // fetch all
        //
        // }
        //
        // if(!window.localStorage?.is_inactive_fse_tab){
        //     toast.warning("Please check in_active fse!");
        //     return false;
        // }
        //
        // if(!window.localStorage?.fse_inventory_tab){
        //     toast.warning("Please check for inventory!")
        //     return false;
        // }
        //
        // if(!window.localStorage?.penalty_percentage_tab){
        //     toast.warning("Please check for penalty!")
        //     return false;
        // }
        //
        // if(!window.localStorage?.fse_tag_transfer_tab){
        //     toast.warning("Please check for tag transfer!")
        //     return false;
        // }

        let inactiveFse  = window.localStorage.inactive_fse ? JSON.parse(window.localStorage.inactive_fse) : [];
        let inventory = window.localStorage.fse_inventory ? JSON.parse(window.localStorage.fse_inventory) : [];

        let tagTransfer = window.localStorage.fse_tag_transfer ? JSON.parse(window.localStorage.fse_tag_transfer): [];
        let penalty = window.localStorage.penalty ? JSON.parse(window.localStorage.penalty) : [];

        let allInactiveFse = true;
        if(Object.keys(inactiveFse).length > 0){
            inactiveFse.map((val => {
                if(!val?.is_active){
                    allInactiveFse = false;
                }
            }))
        }

        if(!allInactiveFse){
            toast.error("You have few remaining task in inactive fse!");
            return true;
        }

        let allInventory = true;
        if(Object.keys(inventory).length > 0){
            inventory.map((val => {
                if(!val?.is_active){
                    allInventory = false;
                }
            }))
        }

        if(!allInventory){
            toast.error("You have few remaining task in inventory!");
            return true;
        }

        let alltagTransfer = true;
        if(Object.keys(tagTransfer).length > 0){
            tagTransfer.map((val => {
                if(!val?.is_active){
                    alltagTransfer = false;
                }
            }))
        }

        if(!alltagTransfer){
            toast.error("You have few remaining task in tag inventory!");
            return true;
        }

        let allpenalty = true;
        if(Object.keys(penalty).length > 0){
            penalty.map((val => {
                if(!val?.is_active){
                    allpenalty = false;
                }
            }))
        }

        if(!allpenalty){
            toast.error("You have few remaining task in penalty!");
            return true;
        }

//50% of the tasks in each bucket should be completed
        // check if operator are found but not action uis taken by asm, am then , not allowed to proceed further for each bucket
        if(Object.keys(inactiveFse).length > 0 && (!window.localStorage.active_fse_percentage || window.localStorage.active_fse_percentage < 50) ) {
            toast.error("Minimum 50% FSEs needs to be activate!");
            return false;
        }

        if(Object.keys(inventory).length > 0 && (window.localStorage.fse_inventory_percentage < 50 || !window.localStorage.fse_inventory_percentage) ){
            toast.error("Inventory to be provided to atleast 50% FSEs!");
            return false;
        }

        if(Object.keys(tagTransfer).length > 0 && (window.localStorage.fse_tag_transfer_percentage < 50 || !window.localStorage.fse_tag_transfer_percentage) ){
            toast.error("Old tag to be transfer back from atleast 50% FSEs!");
            return false;
        }

        if(Object.keys(penalty).length > 0 && (window.localStorage.penalty < 50 || !window.localStorage.penalty) ){
            toast.error("Knowledge transfer discussion to be done for atleast 50% FSEs!");
            return false;
        }

        let selfies = {
            inactive_fse: window.localStorage.inactive_fse_selfie ? JSON.parse(window.localStorage.inactive_fse_selfie) : "",
            inventory: window.localStorage.fse_inventory_selfie ? JSON.parse(window.localStorage.fse_inventory_selfie) : "",
            penalty: window.localStorage.penalty_selfie ? JSON.parse(window.localStorage.penalty_selfie) : "",
            tag_transfer: window.localStorage.fse_tag_transfer_selfie? JSON.parse(window.localStorage.fse_tag_transfer_selfie) : "",
        };

        list['fse_efficiency_selfies'] = selfies;
        list['activity_type_id'] = getActivityDetails?.data?.activity_type_id
        list['account_id'] = getActivityDetails?.data?.account_id
        // list['attendance_regularization'] = isReqularization ? 1 : ''
        list['attendance_regularization'] = ''

        list['activity_date'] = currentDate
        list['fse_details'] = getActivityDetails?.data?.fse_details
        if (list['activity_date'] === '') {
            toast.error("Please choose activity date")
            return false
        }

        if(!versionCheck('3.0.0')) {
            list['lat'] = islatlng?.lat
            list['long'] = islatlng?.lng
        } else {
            list['lat'] = currentUserLocation?.current?.lat
            list['long'] = currentUserLocation?.current?.long
        }

        list['id'] = getActivityDetails?.data?.id
        list['role_id'] = roleId
        list['meta_data']['competitor'] = competitor
        list['fse_details'] = fse
        if (list['long'] == null || list['lat'] == null) {
            handleErrorLogsSave("Please enable your location", "Activity submit");
            toast.error('Please enable your location');
            return false
        }

        // console.log("listlistlistlist " + JSON.stringify(list))
        // return false
        var flag = true
        var mssg=""
        // if(list.fse_details !==null && list.fse_details.length>0){
        //     list.fse_details.map((val)=>{
        //         if(val?.name!==null && flag){
        //             if(val?.description == '' || val?.description == null){
        //                 flag = false
        //                 mssg = 'Add remarks for FSE '+val?.name
        //             }
        //             else if(val?.selfie == '' || val?.selfie == null){
        //                 flag = false
        //                 mssg = 'Take Selfie with FSE '+val?.name
        //             }
        //         }
        //     })
        // }

        if(!flag){
            toast.warning(mssg);
            return false;
        }
        // return;
        setIsLoading(true)
        await activitySave(list)
        setIsLoading(false)
    }

    const handleInput = (key, val, metaKey, e, i = 0) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        if (saveActivityResponse?.status === 200) {
            setOpenCheckIn(false)
            // setCheckInText("Check out")
            toast.success(saveActivityResponse?.message)
            delete window.localStorage.inactive_fse;
            delete window.localStorage.fse_inventory;
            delete window.localStorage.fse_tag_transfer;
            delete window.localStorage.penalty;
            delete window.localStorage.active_fse_percentage;
            delete window.localStorage.fse_inventory_percentage;
            delete window.localStorage.fse_tag_transfer_percentage;
            delete window.localStorage.penalty_percentage;
            delete window.localStorage.fse_tag_transfer_selfie;
            delete window.localStorage.penalty_selfie;
            delete window.localStorage.fse_inventory_selfie;
            delete window.localStorage.inactive_fse_selfie;
            delete window.localStorage.is_inactive_fse_tab;
            delete window.localStorage.fse_inventory_tab;
            delete window.localStorage.penalty_percentage_tab;
            delete window.localStorage.fse_tag_transfer_tab;
            delete window.localStorage.fse_details;
            var returnObj = JSON.parse(window.localStorage?.previous_url);
            if (returnObj && Object.keys(returnObj).length > 0) {
                delete returnObj[Object.keys(returnObj).length - 1]
                window.localStorage.previous_url = JSON.stringify(returnObj)
            }


            window.location.href=`fast-tag-toll-activity-list/${match?.params?.account_id}`;
        } else if (saveActivityResponse?.status !== undefined && saveActivityResponse?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        }
    }, [saveActivityResponse])

    useEffect(() => {
        if (getActivityDetails?.data && Object.keys(getActivityDetails?.data).length > 0
            && isCheckoutDetails?.data && Object.keys(isCheckoutDetails?.data).length > 0) {
            if(isCheckoutDetails?.data?.toll_submission_pjp_id){
                toast.error("Check out from pending PJP Visit.");
                // setTimeout(() => {
                    window.location.href=`fast-tag-toll-activity-list/${match?.params?.account_id}`;
                // }, 1000)
            } else
                if (parseInt(getActivityDetails?.data?.status) === 2
                && isCheckoutDetails?.data?.check_out_lat === null) {
                setOpenCheckIn(true)
                setCheckInText("Check out")
            } else if (parseInt(getActivityDetails?.data?.status) === 1 && isCheckoutDetails?.data?.check_out_lat === null) {
                setOpenCheckIn(false)
            }


            // if(isCheckoutDetails?.data?.attendance_regularization !== null &&
            //     isCheckoutDetails?.data?.attendance_regularization !== undefined && Object.keys(isCheckoutDetails?.data?.attendance_regularization).length > 0){
            //     if(parseInt(getActivityDetails?.data?.activity_id) !== parseInt(match?.params?.id)){
            //         setOpenCheckIn(true)
            //         setCheckInText("Check in")
            //     }
            // }
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [getActivityDetails, isCheckoutDetails])

    useEffect(() => {
        if (tollView?.data !== undefined && tollView?.data?.longitude !== undefined) {
           if(versionCheck('3.0.0')){
               let distance = 0;
               console.log("vgfdsasdfgvfdsa", currentUserLocation.current);
               if(currentUserLocation?.current?.lat && currentUserLocation?.current?.long){
                   distance = distanceBetweenTwoPoints(tollView?.data?.latitude, currentUserLocation?.current?.lat, tollView?.data?.longitude, currentUserLocation?.current?.long);
               }
               if (window.localStorage?.device_id) {
                   setDeviceId(window.localStorage?.device_id)
               } else if(currentUserLocation?.current?.device_id){
                   setDeviceId(currentUserLocation?.current?.device_id)
               } else if (parseInt(window.localStorage.login_preference) === 2) {
                   // check device id is present or not whe user login in app
                   setOpenCheckIn(false);
                   toast.error("Device id is missing!");
               }
               setDistance(parseFloat(distance).toFixed(2))

               if(currentUserLocation?.current?.is_mock){
                   setIsMockLocation(true)
               }
               setTimeout(() => {
                   setIsLoading(true)
                   setIsLoading(false)
               }, 1000)
           }
        }
    }, [tollView, currentUserLocation?.current?.lat])

    useEffect(() => {
        if (tollView?.data !== undefined && tollView?.data?.longitude !== undefined) {
            let distance = 0
            if(!versionCheck('3.0.0')) {
                if(siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN'){
                    console.log("toll complete distance event response "+ JSON.stringify(siteDistance))
                    distance = siteDistance?.distance_in_km;
                    if (siteDistance?.device_id) {
                        setDeviceId(siteDistance?.device_id)
                    } else if (parseInt(window.localStorage.login_preference) === 2) {
                        // check device id is present or not whe user login in app
                        setOpenCheckIn(false);
                        toast.error("Device id is missing!");
                    }
                    setDistance(parseFloat(distance).toFixed(2))
                }
                if(siteDistance?.is_mock){
                    setIsMockLocation(true)
                }
                distance = calcCrow(tollView?.data?.latitude, tollView?.data?.longitude, islatlng?.lat, islatlng?.lng)
                setDistance(parseFloat(distance).toFixed(2))
                setTimeout(() => {
                    setIsLoading(true)
                    setIsLoading(false)
                }, 1000)
            }
        }
    }, [tollView, siteDistance])

    const diff_hours = (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60);
        // return Math.abs(Math.round(diff));
        return diff;
    }

    useEffect(() => {
        if (!isVirtual && parseFloat(distance) > 2) {
            setOpenCheckIn(false)
            toast.warning("Your are outside 2 km radius of the toll")
            handleErrorLogsSave("Your are outside 2 km radius of the toll", checkInText);
            // setIsRegularization(true)
        }

        if(!distance){
            // setOpenCheckIn(false)
        }
    }, [distance])

    // useEffect(() => {
    //     setIsFailedModalOpen(false)
    //     setIsSuccessModalOpen(false)
    //     if (saveActivityResponse?.status === 200) {
    //         // setIsSuccessModalOpen(true)
    //         // setSuccessMessage(saveActivityResponse?.message)
    //         delete window.localStorage.inactive_fse;
    //         delete window.localStorage.fse_inventory;
    //         delete window.localStorage.fse_tag_transfer;
    //         delete window.localStorage.penalty;
    //         delete window.localStorage.active_fse_percentage;
    //         delete window.localStorage.fse_inventory_percentage;
    //         delete window.localStorage.fse_tag_transfer_percentage;
    //         delete window.localStorage.penalty_percentage;
    //         delete window.localStorage.fse_tag_transfer_selfie;
    //         delete window.localStorage.penalty_selfie;
    //         delete window.localStorage.fse_inventory_selfie;
    //         delete window.localStorage.inactive_fse_selfie;
    //         delete window.localStorage.is_inactive_fse_tab;
    //         delete window.localStorage.fse_inventory_tab;
    //         delete window.localStorage.penalty_percentage_tab;
    //         delete window.localStorage.fse_tag_transfer_tab;
    //         // setOpenCheckIn(true)
    //         // setCheckInText("Check Out")
    //         window.location.reload()
    //     } else if (saveActivityResponse?.status !== undefined && saveActivityResponse?.status !== 200) {
    //         setCountToOpenModal(countToOpenModal + 1)
    //         setIsFailedModalOpen(true)
    //         setSuccessMessage(saveActivityResponse?.message)
    //     }
    // }, [saveActivityResponse])

    useEffect(() => {
        if (getActivityDetails?.data !== undefined && Object.keys(getActivityDetails?.data).length > 0) {
            if (parseInt(getActivityDetails?.data?.activity_type_id) === 24) {
                setIsVirtual(true)
            }

            if (parseInt(getActivityDetails?.data?.approval_status) === 1) {
                toast.warning("Activity is not approved yet")
                handleErrorLogsSave("Activity is not approved yet", "Check in");
                setOpenCheckIn(false)
                setIsRegularization(false)
                setTimeout(() => {
                    window.location.href = `fast-tag-toll-activity-list/${match?.params?.account_id}`
                }, 1000)
            }
        }
    }, [getActivityDetails])

    const handleOpenSelfieTab = (i) => {
        setTakeSelfie(takeSelfie)
        setPrev(i)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 200)
    }

    const refCamera = useRef(
        <Camera
            idealFacingMode={'user'}
            idealResolution={{
                width: 600,
                height: 480
            }}
            onTakePhoto={(dataUri) => {
                (async () => {
                    setIsLoading(true)
                    await documentUploadUrlPublic({ base_64_file: dataUri })
                    setIsLoading(false)
                })()
                // setSelfie(dataUri);
                // setRetake(false)
            }}
        />
    )
    // useEffect(() => {
    //     if (documentUrlDataPublic?.file_url !== undefined && getActivityDetails.data.fse_details !== null &&
    //         getActivityDetails.data.fse_details[prev] !== undefined &&
    //         getActivityDetails.data.fse_details[prev] !== null) {
    //         getActivityDetails.data.fse_details[prev].selfie = documentUrlDataPublic?.file_url
    //     }
    // }, [documentUrlDataPublic])

    const handleRemoveCompetitor = (e, index) => {
        const list = [...competitor]
        list.splice(index, 1);
        setCompetitor(list);
        e.preventDefault()
    }

    const handleFSEAdd = () => {
        setFSE([
            ...fse,
            {phone_no: '', otp: '', text: "Send OTP", selfie: ''}
        ])
    }

    const handleRemoveFSE = (e, index) => {
        const list = [...fse]
        list.splice(index, 1);
        setFSE(list);
        setIsLoading(true)
        window.localStorage.fse_details = JSON.stringify(list)
        setIsLoading(false)
    }

    const handleFSEInput = (key, value, index) => {
        const list = [...fse];
        let isDuplicate = false
        list[index][key] = value;
        setFSE(list)
        window.localStorage.fse_details = JSON.stringify(fse)
    }

    const handleCompetitorInput = (key, value, index) => {
        const list = [...competitor];
        list[index][key] = value;
        console.log(value)
        setCompetitor(list)
    }

    const handleConfirmationModal = (index) => {
        serCurrentIndex(index)
        handleFSEInput('selfie', '', index)
        setOpen(true)
    }

    const handleCloseConfirmationModal = () => {
        setIsLoading(true)
        serCurrentIndex('')
        setOpen(false)
        setIsLoading(false)
    }

    useEffect(() => {
        if(documentUrlDataPublic?.file_url !== undefined && currentIndex !== ''){
            handleFSEInput('selfie', documentUrlDataPublic?.file_url, currentIndex)
        }
    }, [documentUrlDataPublic]);

    const handleCompetitorAdd = () => {
        setCompetitor([
            ...competitor,
            {name:'', bank: '', employee_type: '', no_of_fse: '', salary: '', min_tags: '', tag_sold: '', upload_proof: ''}
        ])
    }

    useEffect(() => {
        if(isMockLocation){
            setOpenCheckIn(false)
            setHideCheckIn(true)
            setDisableSubmit(true)
            // toast.error('Location morphing is cheating. Check in not allowed');
            handleErrorLogsSave(`Location morphing is cheating. ${checkInText} not allowed`, checkInText);
            setCountToOpenModal(countToOpenModal+1);
        }
    }, [isMockLocation])

    const handleErrorLogsSave = async (msg, type) => {
        setIsLoading(true)
        await errorLogs({
            module_type:"Fastag Toll",
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        })
        setIsLoading(false)
    }

    useEffect( () => {
        (async () => {
            console.log("tollView",taskType)
            if(getInactiveFsesResponse?.data && checkInText === 'Check In'){
                if(taskType === 'inactive' && window.localStorage.inactive_fse === undefined){
                    window.localStorage.inactive_fse = getInactiveFsesResponse?.data?.inactive_operator_list && getInactiveFsesResponse?.data?.inactive_operator_list.length > 0 ?
                        JSON.stringify(getInactiveFsesResponse?.data?.inactive_operator_list) : [];
                    setTakType("penalty")
                    await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'penalty');
                } else if(taskType === 'penalty' && window.localStorage.penalty === undefined){
                    window.localStorage.penalty =  getInactiveFsesResponse?.data?.operator_penalty_list && getInactiveFsesResponse?.data?.operator_penalty_list.length > 0 ?
                        JSON.stringify(getInactiveFsesResponse?.data?.operator_penalty_list) : []
                    await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'tag_transfer');
                    setTakType("tag_transfer")
                } else if(taskType === 'tag_transfer' && window.localStorage.fse_tag_transfer === undefined){
                    window.localStorage.fse_tag_transfer = getInactiveFsesResponse?.data?.operators_with_upcoming_old_inventory_list && getInactiveFsesResponse?.data?.operators_with_upcoming_old_inventory_list.length > 0 ?
                        JSON.stringify(getInactiveFsesResponse?.data?.operators_with_upcoming_old_inventory_list) : []
                    await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'inventory');
                    setTakType("inventory")
                } else if(taskType === 'inventory' && window.localStorage.fse_inventory === undefined){
                    window.localStorage.fse_inventory = getInactiveFsesResponse?.data?.low_inventory_operator_list && getInactiveFsesResponse?.data?.low_inventory_operator_list.length > 0 ?
                        JSON.stringify(getInactiveFsesResponse?.data?.low_inventory_operator_list) : []
                    setTakType("")
                }
            }

            if(!window.localStorage.inactive_fse ){
                setTakType("inactive")
            } else if(!window.localStorage.penalty){
                setTakType("penalty")
            }
            else if(!window.localStorage.fse_tag_transfer){
                setTakType("tag_transfer")
            }
            else if(!window.localStorage.fse_inventory){
                setTakType("inventory")
            } else{
                setTakType("")
            }
        })();
    }, [getInactiveFsesResponse, taskType, getActivityDetails]);

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if(webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }

    return (
        <>
            {/*<SuccessModal*/}
            {/*    isOpen={isSuccessModalOpen}*/}
            {/*    msg={successMessage}*/}
            {/*    url={`fast-tag-toll-activity-list/${match?.params?.account_id}`}*/}
            {/*/>*/}
            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={`fast-tag-toll-activity-list/${match?.params?.account_id}`}
                />
            }

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
            // url={backUrl}
            />
            <Loader isLoading={isLoading} />
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Selfie</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {handleCloseConfirmationModal()}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {window.localStorage.fse_details && JSON.parse(window.localStorage.fse_details) && JSON.parse(window.localStorage.fse_details)[currentIndex]['selfie'] ?
                                        <img alt="selfie" src={JSON.parse(window.localStorage.fse_details)[currentIndex]['selfie']}/>
                                        :
                                        <Camera
                                            idealFacingMode={'user'}
                                            idealResolution={{
                                                width: 600,
                                                height: 480
                                            }}
                                            onTakePhoto={(dataUri) => {
                                                (async () => {
                                                    setIsLoading(true)
                                                    await documentUploadUrlPublic({ base_64_file: dataUri })
                                                    setIsLoading(false)
                                                })()
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {console.log("currentUserLocation?.current?.lat", currentUserLocation?.current?.lat,  openCheckIn)}
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            <>
                                {!isVirtual && openCheckIn ?
                                    <div className="popup-box">
                                        <div className="box">
                                            {!versionCheck('3.0.0') ?
                                                <DistanceCalculator
                                                    isMapShow={true}
                                                    calculateDistance={markAttendance}
                                                    moduleType={'Fasttag Toll'}
                                                    checkInText={checkInText}
                                                    checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                                    activityId={getActivityDetails?.data?.id !== undefined ? getActivityDetails?.data?.id : ""}
                                                    accountId={getActivityDetails?.data?.account_id !== undefined ? getActivityDetails?.data?.account_id : ""}
                                                    documentUploadUrlPublic={documentUploadUrlPublic}
                                                    documentUrlDataPublic={documentUrlDataPublic}
                                                    attendanceResponse={attendance}
                                                    deviceId={deviceId}
                                                    deviceIdCheck={true}
                                                    hideCheckButton={hideCheckIn}
                                                /> :
                                                currentUserLocation?.current?.lat &&
                                                <DistanceCalculatorV2
                                                    isMapShow={true}
                                                    calculateDistance={markAttendance}
                                                    moduleType={'Fasttag Toll'}
                                                    checkInText={checkInText}
                                                    checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                                    activityId={getActivityDetails?.data?.id !== undefined ? getActivityDetails?.data?.id : ""}
                                                    accountId={getActivityDetails?.data?.account_id !== undefined ? getActivityDetails?.data?.account_id : ""}
                                                    documentUploadUrlPublic={documentUploadUrlPublic}
                                                    documentUrlDataPublic={documentUrlDataPublic}
                                                    attendanceResponse={attendance}
                                                    deviceId={deviceId}
                                                    deviceIdCheck={true}
                                                    hideCheckButton={hideCheckIn}
                                                />
                                            }
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <form onSubmit={(e) => handleSubmit(e)}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    {!versionCheck('3.0.0') ?
                                                        <div
                                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                            <h1 className="h3 mb-0 text-black-100">
                                                                {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                                <span
                                                                    style={{color: "green"}}> {distance} km away from toll</span>
                                                            </h1>
                                                        </div> :
                                                        <div
                                                            className="d-flex align-items-center justify-content-between com-sub-heading">
                                                            {isLocationFetching ? "Location fetching..." : ""}
                                                            {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                                                <span
                                                                    style={{color: "green"}}
                                                                    className="ml-5">{distance} km away from toll
                                                            </span> :
                                                                <h1 className="h3 mb-0 text-black-100">
                                                                    {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                                    <span
                                                                        style={{color: "green"}}
                                                                        className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                            application</span>
                                                                </h1>
                                                            }
                                                            <button className="btn btn-primary mr-4" onClick={(e) => {
                                                                refreshUserLocation(e)
                                                            }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                                        </div>
                                                    }

                                                    {/*<div className="mb-0 bg-white">*/}
                                                    <div className="card-body bg-white">
                                                        <div className="user">
                                                            <div className="form-group row">
                                                                <div className="col-sm-6 mt-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleInput('activity_type_id', e.target.value, e)
                                                                        }}
                                                                        disabled={true}>
                                                                        <option value="">Select Activity
                                                                        </option>
                                                                        {types?.data !== undefined && types?.data.map((val) => {
                                                                            return (
                                                                                <>
                                                                                    {(getActivityDetails?.data?.activity_type_id !== undefined &&
                                                                                        getActivityDetails?.data?.activity_type_id === parseInt(val?.id)) ?
                                                                                        <option
                                                                                            value={val?.id}
                                                                                            selected={true}>{val.name}
                                                                                        </option> :
                                                                                        <option
                                                                                            value={val?.id}>{val.name}
                                                                                        </option>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Activity Type
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 float-field">
                                                                    <input type="datetime-local"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput('activity_date', e.target.value, e)
                                                                               setCurrentDate(e.target.value)
                                                                           }}
                                                                           id="validationCustom01"
                                                                           disabled={true}
                                                                           value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date : ""}
                                                                           max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                                        // value={currentDate}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Activity Date
                                                                    </label>
                                                                </div>
                                                                {getActivityDetails?.data?.cReason !== undefined &&
                                                                    <>
                                                                        <div
                                                                            className="col-sm-6 mt-1 float-field mb-3">
                                                                            <textarea
                                                                                className="form-control form-control-user"
                                                                                placeholder=" Remark"
                                                                                onChange={(e) => {
                                                                                    // handleInput('meta_data', e.target.value, 'remark', e)
                                                                                }}
                                                                                rows="4" cols="50"
                                                                                disabled={true}
                                                                                value={getActivityDetails?.data?.cReason}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                {/*Remark*/}
                                                                            </label>
                                                                        </div>
                                                                    </>
                                                                }

                                                                {/*{getActivityDetails?.data?.fse_details !== null && Object.keys(getActivityDetails?.data?.fse_details).length > 0*/}
                                                                {/*    && getActivityDetails?.data?.fse_details.map((val, i) => {*/}
                                                                {/*        return (*/}
                                                                {/*            <>*/}
                                                                {/*                {val?.name !== null && val?.name !== '' &&*/}
                                                                {/*                    <div className="col-sm-6 mtk-075 float-field">*/}
                                                                {/*                        <input type="text"*/}
                                                                {/*                               className="form-control form-control-user"*/}
                                                                {/*                               placeholder=" "*/}
                                                                {/*                               id="validationCustom01"*/}
                                                                {/*                               disabled={true}*/}
                                                                {/*                               value={val?.name}*/}
                                                                {/*                        />*/}
                                                                {/*                        <label className="large-label float-lb">*/}
                                                                {/*                            FSE*/}
                                                                {/*                        </label>*/}
                                                                {/*                    </div>*/}
                                                                {/*                }*/}
                                                                {/*                {val?.name!=null && <>*/}
                                                                {/*                    <div className="col-sm-6 mtk-075 float-field">*/}
                                                                {/*                    <textarea*/}
                                                                {/*                        className="form-control form-control-user"*/}
                                                                {/*                        placeholder={"Add Remarks for "+val?.name}*/}
                                                                {/*                        onChange={(e) => {*/}
                                                                {/*                            // handleInput('meta_data', e.target.value, 'description', e)*/}
                                                                {/*                            val.description = e.target.value*/}
                                                                {/*                        }}*/}
                                                                {/*                        rows="4" cols="50"*/}
                                                                {/*                        value={val?.remark}*/}
                                                                {/*                    />*/}
                                                                {/*                        <label className="large-label float-lb">*/}

                                                                {/*                        </label>*/}
                                                                {/*                    </div>*/}
                                                                {/*                <div className="col-sm-6 mtk-075 float-field" key={i}>*/}
                                                                {/*                    {!takeSelfie[i] ?*/}
                                                                {/*                        <a*/}
                                                                {/*                            className="btn btn-info btn-user btn-block submit-btn"*/}
                                                                {/*                            onClick={() => {*/}
                                                                {/*                                takeSelfie[i] = true;*/}
                                                                {/*                                handleOpenSelfieTab(i)*/}
                                                                {/*                            }}*/}
                                                                {/*                        >*/}
                                                                {/*                            Take Selfie with FSE*/}
                                                                {/*                        </a> :*/}
                                                                {/*                        val?.selfie !== "" && val?.selfie !== null*/}
                                                                {/*                            ? <>*/}
                                                                {/*                                <img*/}
                                                                {/*                                    src={`${val?.selfie}`} />*/}
                                                                {/*                                <a*/}
                                                                {/*                                    className="btn btn-info btn-user btn-block submit-btn"*/}
                                                                {/*                                    onClick={() => {*/}
                                                                {/*                                        getActivityDetails.data.fse_details[i].selfie = null*/}
                                                                {/*                                        takeSelfie[i] = true;*/}
                                                                {/*                                        handleOpenSelfieTab(i)*/}
                                                                {/*                                        setTimeout(()=>{*/}
                                                                {/*                                            setIsLoading(true)*/}
                                                                {/*                                            setIsLoading(false)*/}
                                                                {/*                                        },400)*/}
                                                                {/*                                        */}
                                                                {/*                                    }}*/}
                                                                {/*                                >*/}
                                                                {/*                                    Retry*/}
                                                                {/*                                </a></>*/}
                                                                {/*                            :*/}
                                                                {/*                            takeSelfie[i] &&*/}
                                                                {/*                            refCamera.current*/}
                                                                {/*                    }*/}
                                                                {/*                </div></>}*/}
                                                                {/*            </>*/}
                                                                {/*        )*/}
                                                                {/*    })}*/}
                                                                {/*<div className="col-sm-6 mt-1 float-field">*/}
                                                                {/*    <select*/}
                                                                {/*        className="form-control form-control-user"*/}
                                                                {/*        onChange={(e) => {*/}
                                                                {/*            handleInput('meta_data', e.target.value, 'Stage', e)*/}
                                                                {/*        }}*/}
                                                                {/*    >*/}
                                                                {/*        <option value="">Select Stage*/}
                                                                {/*        </option>*/}
                                                                {/*        <option*/}
                                                                {/*            value="Hot">Hot*/}
                                                                {/*        </option>*/}
                                                                {/*        <option*/}
                                                                {/*            value="Cold">Cold*/}
                                                                {/*        </option>*/}
                                                                {/*        <option*/}
                                                                {/*            value="Warm">Warm*/}
                                                                {/*        </option>*/}
                                                                {/*    </select>*/}
                                                                {/*    <label className="large-label float-lb">*/}
                                                                {/*        Stage*/}
                                                                {/*    </label>*/}
                                                                {/*</div>*/}

                                                                {/*<div className="col-sm-6 mtk-1 float-field mb-3">*/}
                                                                {/*    <FileUpload*/}
                                                                {/*        id={"addAttachment"}*/}
                                                                {/*        accept=".png,.jpg,.jpeg"*/}
                                                                {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                                                {/*        documentUrlData={documentUrlDataPublic}*/}
                                                                {/*        onChange={(e, val) => {*/}
                                                                {/*            handleInput('meta_data', e, 'Document', e)*/}
                                                                {/*        }}*/}
                                                                {/*        prefilledFilename={""}*/}
                                                                {/*        multiple={true}*/}
                                                                {/*    >*/}
                                                                {/*        File Attachment*/}
                                                                {/*    </FileUpload>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/*</div>*/}
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div
                                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading"
                                                                style={{backgroundColor: 'bisque'}}>
                                                                <h1 className="h3 mb-0 text-black-100"><b>FSE
                                                                    Catchup</b></h1>
                                                            </div>
                                                            <div className="card-body bg-white">
                                                                <div className="user">
                                                                    <div className="form-group row">
                                                                        {fse && fse.map((val, i) => {
                                                                            return (
                                                                                <>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="number"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                            // disabled={val?.phone_no}
                                                                                               onChange={(e) => {
                                                                                                   handleFSEInput('phone_no', e.target.value, i)
                                                                                               }}
                                                                                               value={val?.phone_no ?? ""}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Phone No
                                                                                        </label>
                                                                                    </div>
                                                                                    {/*<div className="col-md-6 float-field ">*/}
                                                                                    {/*    <input type="text"*/}
                                                                                    {/*           className="form-control form-control-user"*/}
                                                                                    {/*           placeholder=" "*/}
                                                                                    {/*           onChange={(e) => {handleFSEInput('otp', e.target.value, i)}}*/}

                                                                                    {/*    />*/}
                                                                                    {/*    <label className="large-label float-lb">*/}
                                                                                    {/*        Enter OTP*/}
                                                                                    {/*    </label>*/}
                                                                                    {/*</div>*/}

                                                                                    {/*<div className="col-md-3 mb-4">*/}
                                                                                    {/*    <a className={`btn btn-primary btn-user btn-block ${val?.text === 'OTP Verified' ? "bg-green text-white" :""}`} onClick={() => {handleOtpGeneration(val?.phone_no, i)}}*/}
                                                                                    {/*       disabled={val?.text === 'OTP Verified'}>*/}
                                                                                    {/*        {val?.text}*/}
                                                                                    {/*    </a>*/}
                                                                                    {/*</div>*/}
                                                                                    {/*{val?.text === "Check OTP" &&*/}
                                                                                    {/*    <div className="col-md-3">*/}
                                                                                    {/*        <a className="btn btn-primary btn-user btn-block" onClick={() => {resentOTP(val?.phone_no)}}*/}
                                                                                    {/*           disabled={val?.text === 'OTP Verified'}>*/}
                                                                                    {/*            Resend OTP*/}
                                                                                    {/*        </a>*/}
                                                                                    {/*    </div>*/}
                                                                                    {/*}*/}
                                                                                    <div className="col-md-3 mb-4">
                                                                                        {val?.selfie ?
                                                                                            // eslint-disable-next-line react/jsx-no-target-blank
                                                                                            <a className="btn btn-primary btn-user btn-block"
                                                                                               href={val?.selfie}
                                                                                               target="_blank">Selfie</a>
                                                                                            :

                                                                                            <a className="btn btn-primary btn-user btn-block"
                                                                                               data-toggle="modal"
                                                                                               data-target="#exampleModalCenter"
                                                                                               onClick={() => {
                                                                                                   handleConfirmationModal(i)
                                                                                               }}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="16"
                                                                                                    height="16"
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-camera mr-2"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path
                                                                                                        d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z"/>
                                                                                                    <path
                                                                                                        d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
                                                                                                </svg>
                                                                                                Capture Selfie
                                                                                            </a>
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 mb-4">
                                                                                        {val?.selfie &&
                                                                                            <a className="btn btn-primary btn-user btn-block bg-red"
                                                                                               data-toggle="modal"
                                                                                               data-target="#exampleModalCenter"
                                                                                               onClick={() => {
                                                                                                   handleConfirmationModal(i)
                                                                                               }}>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="16"
                                                                                                    height="16"
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-camera mr-2"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path
                                                                                                        d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z"/>
                                                                                                    <path
                                                                                                        d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
                                                                                                </svg>
                                                                                                Remove Selfie
                                                                                            </a>
                                                                                        }
                                                                                    </div>
                                                                                    <div
                                                                                        className="btn-box mb-4"
                                                                                        style={{"width": "100%"}}>
                                                                                        {fse.length !== 1 &&
                                                                                            <button
                                                                                                onClick={(e) => handleRemoveFSE(e, i)}
                                                                                                className="btn btn-sm btn-danger ml-3">Remove
                                                                                                FSE
                                                                                            </button>
                                                                                        }
                                                                                        {fse.length - 1 === i &&
                                                                                            <button
                                                                                                className="btn btn-sm btn-primary ml-3"
                                                                                                onClick={(e) => handleFSEAdd()}>Add
                                                                                                FSE
                                                                                            </button>
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div
                                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading"
                                                                style={{backgroundColor: 'bisque'}}>
                                                                <h1 className="h3 mb-0 text-black-100"><b>Add Competitor
                                                                    Analysis</b></h1>
                                                            </div>
                                                            {competitor.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="card-body bg-white">
                                                                            <div className="user">
                                                                                <div className="form-group row">
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="text"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('name', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}

                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Competitor Name
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="text"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('bank', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            FASTag Bank Name
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                                        <select
                                                                                            className="form-control form-control-user"
                                                                                            onChange={(e) => {
                                                                                                handleCompetitorInput('employee_type', e.target.value, i,)
                                                                                            }} required={true}>
                                                                                            <option value="">Select
                                                                                                Employee Type
                                                                                            </option>
                                                                                            <option
                                                                                                value="Salaried">Salaried
                                                                                            </option>
                                                                                            <option
                                                                                                value="Commission">Commission
                                                                                            </option>
                                                                                            <option
                                                                                                value="Salaried + Commission">Salaried
                                                                                                + Commission
                                                                                            </option>
                                                                                        </select>
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Employee Type <i
                                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="number"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('no_of_fse', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Number of FSEs
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="float"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('salary', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Monthly Salary
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="float"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('min_tags', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Min. Number of tags sold to
                                                                                            be eligible for salary
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 float-field ">
                                                                                        <input type="float"
                                                                                               className="form-control form-control-user"
                                                                                               placeholder=" "
                                                                                               onChange={(e) => {
                                                                                                   handleCompetitorInput('tag_sold', e.target.value, i,)
                                                                                               }}
                                                                                               required={true}
                                                                                        />
                                                                                        <label
                                                                                            className="large-label float-lb">
                                                                                            Monthly tags sold
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-sm-6 mtk-1 float-field mb-3"
                                                                                        key={i}>
                                                                                        <FileUpload
                                                                                            id={`addAttachment`}
                                                                                            accept=".png,.jpg,.jpeg"
                                                                                            documentUploadUrl={documentUploadUrlPublic}
                                                                                            documentUrlData={documentUrlDataPublic}
                                                                                            onChange={(e, val) => {
                                                                                                handleCompetitorInput('upload_proof', e, i,)
                                                                                            }}
                                                                                            required={true}
                                                                                            prefilledFilename={""}
                                                                                            multiple={true}
                                                                                        >
                                                                                            Upload Proof
                                                                                        </FileUpload>
                                                                                    </div>
                                                                                    <div
                                                                                        className="btn-box mb-4"
                                                                                        style={{"width": "100%"}}>
                                                                                        {competitor.length !== 1 &&
                                                                                            <button
                                                                                                onClick={(e) => handleRemoveCompetitor(e, i)}
                                                                                                className="btn btn-sm btn-danger ml-3">Remove
                                                                                            </button>
                                                                                        }
                                                                                        {competitor.length - 1 === i &&
                                                                                            <button
                                                                                                className="btn btn-sm btn-primary ml-3"
                                                                                                onClick={(e) => handleCompetitorAdd()}>Add
                                                                                            </button>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}

                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 mt-1 float-field mb-3">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder=" Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('meta_data', e.target.value, 'remark', e)
                                                                        }}
                                                                        rows="4" cols="50"
                                                                    />
                                                        <label className="large-label float-lb">
                                                            {/*Remark*/}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-12 mt-4 d-flex">
                                                        <button
                                                            className="btn btn-primary btn-user btn-block submit-btn"
                                                            // disabled={(!isVirtual && parseInt(distance) > 2) ||
                                                            //     parseInt(getActivityDetails?.data?.approval_status) === 1}
                                                            disabled={(parseInt(roleId) === 30 && parseInt(hours) < 1) || (parseInt(roleId) === 29 && parseInt(hours) < 1) || disableSubmit}
                                                        >
                                                            Submit
                                                        </button>
                                                        {/*{isReqularization && parseInt(getActivityDetails?.data?.approval_status) === 2 && !openCheckIn ?*/}
                                                        {/*    <button*/}
                                                        {/*        className="btn btn-primary btn-user btn-block submit-btn"*/}
                                                        {/*    >*/}
                                                        {/*        Send for approval*/}
                                                        {/*    </button>*/}
                                                        {/*     :*/}
                                                        {/*    <>*/}
                                                        {/*        <button*/}
                                                        {/*            className="btn btn-primary btn-user btn-block submit-btn"*/}
                                                        {/*            disabled={(!isVirtual && parseInt(distance) > 500) ||*/}
                                                        {/*                parseInt(getActivityDetails?.data?.approval_status) === 1}*/}
                                                        {/*        >*/}
                                                        {/*            Submit*/}
                                                        {/*        </button>*/}
                                                        {/*    </>*/}
                                                        {/*}*/}

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </>
                                }
                                {!isReqularization &&
                                    <>

                                        {/*{!openCheckIn && parseInt(getActivityDetails?.data?.approval_status) !== 1 &&*/}
                                        {/*    getActivityDetails?.data?.in_attendance_regularization === null &&*/}
                                        {/*    <>*/}
                                        {/*        <div className="col-md-12 mt-4 d-flex">*/}
                                        {/*            <button*/}
                                        {/*                className="btn btn-primary btn-user btn-block submit-btn"*/}
                                        {/*                onClick={() => setIsRegularization(true)}*/}
                                        {/*            >*/}
                                        {/*                Attendance Regularization*/}
                                        {/*            </button>*/}
                                        {/*        </div>*/}
                                        {/*    </>*/}
                                        {/*}*/}
                                    </>
                                }
                                {/*{isReqularization &&*/}
                                {/*    <AttendanceRequest*/}
                                {/*        moduleType={"Fasttag Toll"}*/}
                                {/*        activityId={getActivityDetails?.data?.id}*/}
                                {/*        documentUploadUrlPublic={documentUploadUrlPublic}*/}
                                {/*        documentUrlDataPublic={documentUrlDataPublic}*/}
                                {/*        attendanceRequest={attendanceRequest}*/}
                                {/*        makeAttendanceRequest={makeAttendanceRequest}*/}
                                {/*        match={match}*/}
                                {/*        history={history}*/}
                                {/*        lat={islatlng?.lat}*/}
                                {/*        long={islatlng?.lng}*/}
                                {/*    />*/}
                                {/*}*/}
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default CompleteFastTagTollActivity